import React, { act, useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { BsTrashFill } from "react-icons/bs";

import "./timeline.css";

export default function Form({
    title,
    project,
    defaultValues = {},
    onSubmit = () => { },
    back = () => { },
}) {
    const [p, setP] = React.useState(defaultValues?.progress?.value || 0)

    React.useEffect(() => {
        if (p == 0) {
            changeProgress(p)
        }
    }, [])

    const {
        handleSubmit,
        control,
        setValue,
        formState: { errors },
        watch
    } = useForm({
        defaultValues,
        mode: "all",
        shouldFocusError: true,
    });

    const changeProgress = (p) => {
        let t = { ...(defaultValues?.progress || {}), value: p }
        let deadline = watch("deadline")
        if (deadline) {
            t[p] = new Date(deadline).toISOString()
        } else {
            t[p] = new Date().toISOString()
        }
        setValue("progress", t)
    }

    const onDateChange = (e, key, action) => {

        let data = watch("progress")
        if (action == "delete") {
            delete data[key]
            let value = Math.max(...Object.keys(data).filter((k) => !isNaN(k)).map((k) => parseInt(k)))
            data.value = value
            setValue("progress", { ...data })
            return
        }

        data[key] = e.target.value
        setValue("progress", data)
    }

    function getProjectEndDate(startDate, duration) {
        // Convert to JS Date
        const start = new Date(startDate);
        console.log(startDate)
        // Add duration (in days)
        start.setDate(start.getDate() + Number(duration || 0));

        return start.toISOString().split("T")[0]; // format: YYYY-MM-DD
    }



    return (
        <Box sx={{ pb: 2 }}>
            <h2 className="input-label">{title}</h2>
            <form onSubmit={handleSubmit(onSubmit)}>
                {/* {JSON.stringify(watch("progress"))} */}
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <RFG name="task_name" label="Task Name" control={control}
                            rules={{
                                required: true, maxLength: 100,
                            }} className="mb-2">
                            <input autoComplete="off" placeholder="Task Name" />
                        </RFG>

                        <RFG name="deadline" label="Dead Line" control={control}
                            className="mb-2">
                            <input autoComplete="off" placeholder="Dead Line"
                                value={'2025-12-06'} type="date"
                                min={project?.start_project_date?.split("T")[0]}
                                max={project?.end_project_date?.split("T")[0]}
                            />
                        </RFG>
                        <Box className="input-label">
                            <label for="file">Progress</label>
                            <input type="range" min="0" step={1} max="100" value={p} onChange={(e) => {
                                if (parseInt(defaultValues?.progress?.value || 0) <= e.target.value) {
                                    setP(e.target.value)
                                    changeProgress(e.target.value)
                                }
                            }
                            } class="slider" />
                            <label>Progress: {p != 0 ? (p + "%") : "Not Started"}</label>
                        </Box>
                        <Box className="input-label">
                            <table className="timeline-table">
                                <tbody>
                                    {Object.keys(watch("progress") || {}).map((p, i) => {
                                        if (isNaN(p)) return null
                                        let t = (watch("progress")[p]).split("T")[0]
                                        console.log("DATA", t)
                                        return <tr key={p}>
                                            <td width={30}>{(i + 1)}</td>
                                            <td width={100}>{p}%</td>
                                            <td><input type="date" min={project?.start_project_date.split("T")[0]} max={watch("deadline")} value={t} onChange={(e) => onDateChange(e, p, "")} /></td>
                                            <td width={30}><BsTrashFill onClick={(e) => onDateChange(e, p, "delete")} /></td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </Box>

                        <Box textAlign="right" sx={{ my: 4 }}>
                            <Button className="btn-primary" sx={{ mx: 2 }} onClick={back}>
                                Back
                            </Button>
                            <Button
                                onClick={(e) => setValue("action", e.target.innerText)}
                                className="btn-primary"
                                type="submit"
                            >
                                {defaultValues.id ? "UPDATE" : "ADD"}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </form>
        </Box>
    );
}
